import { ProgramAvailablity, ProgramType } from "src/enums";
import { ProgramInfo, ProgramMessage, Promotions, QualityConfig, Stream } from "src/models";
import { PlayerUrl } from "src/models/player/player.urls";
import { ProgramViewTypes } from "../types";
import { createAction } from "./create.action";

export namespace ProgramViewAction {

    export const showLoading = () => createAction(ProgramViewTypes.SHOW_PROGRAM_VIEW_LOADING);
    export const hideLoading = () => createAction(ProgramViewTypes.HIDE_PROGRAM_VIEW_LOADING);

    export const requestProgramInfo = (id: number, programType?: ProgramType) => createAction(ProgramViewTypes.REQUEST_PROGRAM_VIEW_INFO, { id, programType });
    export const setProgramInfo = (model?: ProgramInfo) => createAction(ProgramViewTypes.SET_PROGRAM_VIEW_INFO, model);
    export const setProgramStatus = (status: ProgramAvailablity) => createAction(ProgramViewTypes.SET_PROGRAM_VIEW_STATUS, status);
    export const lockProgram = () => createAction(ProgramViewTypes.SET_PROGRAM_LOCKED);

    export const requestProgramStreamData = (stream: Stream, qualityConfig?: QualityConfig) => createAction(ProgramViewTypes.REQUEST_PROGRAM_STREAM_DATA, { stream, qualityConfig });

    export const setProgramMessage = (message: ProgramMessage) => createAction(ProgramViewTypes.SET_PROGRAM_MESSAGE, message);
    export const clearProgramMessage = () => createAction(ProgramViewTypes.CLEAR_PROGRAM_MESSAGE);

    export const setProgramPlayerData = (player: PlayerUrl, programId?: number) => createAction(ProgramViewTypes.SET_PROGRAM_PLAYER_DATA, { ...player, programId });
    export const clearProgramPlayerData = () => createAction(ProgramViewTypes.CLEAR_PROGRAM_PLAYER_DATA);

    export const requestChangeStream = (stream: Stream) => createAction(ProgramViewTypes.SET_CURRENT_STREAM, stream);

    export const clearProgramInfo = () => createAction(ProgramViewTypes.CLEAR_PROGRAM_VIEW_INFO);

    export const startReporting = (streamId: number) => createAction(ProgramViewTypes.START_PLAYBACK_REPORTING, { streamId });
    export const stopReporting = () => createAction(ProgramViewTypes.STOP_PLAYBACK_REPORTING);
    export const reportPlayback = (payload?: any) => createAction(ProgramViewTypes.DO_REPORT_PLAYBACK, payload);
    export const reportStatistic = (payload?: any) => createAction(ProgramViewTypes.DO_REPORT_STATISTIC, payload);
    export const setOtherSessions = (sessions: string[]) => createAction(ProgramViewTypes.SET_OTHER_SESSIONS, sessions);

    export const decreaseRemainingTime = () => createAction(ProgramViewTypes.DECREASE_REAMININ_TIME);

    export const checkIp = () => createAction(ProgramViewTypes.CHECK_FORBIDDEN_IP);
    export const IpChecked = (succeed: boolean, message: string) => createAction(ProgramViewTypes.FORBIDDEN_IP_CHECKED, { succeed, message });

    export const toggleEconomic = (stream: Stream, economic: boolean) => createAction(ProgramViewTypes.TOGGLE_ECONOMIC, { stream, economic });

    export const setPromotion = (promotion: Promotions) => createAction(ProgramViewTypes.SET_PROMOTION, promotion);
}